import React, { useEffect, useMemo, useState } from "react";
import { SubHeader } from "@components/atoms/sub-header/sub-header";
import { SubTitle } from "@components/atoms/sub-title/sub-title";
import { IconButton } from "@components/atoms/buttons/icon-button/icon-button";
import { Button } from "@components/atoms/buttons/button/button";
import closeIcon from "@src/assets/svg/close-icon.svg";
import styles from "./bulk-edit-data-acquisition-type-modal.module.scss";
import { BulkDataAcquisitionTypeAndIntervalInputsWrapper } from "../bulk-data-acquisition-type-and-interval-inputs-wrapper/bulk-data-acquisition-type-and-interval-inputs-wrapper";
import { useDispatch } from "react-redux";
import {
  updateShowBulkEditDataAcquisitionTypeModal,
  updateStructureWasSaved,
} from "@src/reducers/your-reducer";
import { overwriteSelectedOurNodesWithNewDataAcquisitionValues } from "@src/cloud-connect/use-cases/overwrite-selected-our-nodes-with-new-data-acquisition-values";
import { processSelectedOurNodes } from "./providers/process-selected-our-nodes";
import { useI18N } from "@src/language/language-context";
const cssClassName = "bulk-edit-data-acquisition-type-modal";

export const BulkEditDataAcquisitionModal = () => {
  const dispatch = useDispatch();
  const i18n = useI18N();

  const [localDataAcquisitionType, setLocalDataAcquisitionType] = useState("");
  const [localPollingIntervalInSeconds, setLocalPollingIntervalInSeconds] =
    useState(0);

  const [
    localFlatArrayWithAcquisitionTypes,
    setLocalFlatArrayWithAcquisitionTypes,
  ] = useState([]);

  const callbackForDataAcquisitionTypeValue = (dataAcquisitionTypeValue) => {
    setLocalDataAcquisitionType(dataAcquisitionTypeValue);
  };

  const callbackForPollingIntervalTime = (timeValue: number) => {
    setLocalPollingIntervalInSeconds(timeValue);
  };

  const manageDisableApplyButton = useMemo(() => {
    return () => localDataAcquisitionType === "Mixed";
  }, [localDataAcquisitionType]);

  const closeModalClickHandler = () => {
    dispatch(updateShowBulkEditDataAcquisitionTypeModal(false));
  };

  const applyChanges = () => {
    overwriteSelectedOurNodesWithNewDataAcquisitionValues(
      localDataAcquisitionType.toUpperCase(),
      localPollingIntervalInSeconds,
    );

    dispatch(updateShowBulkEditDataAcquisitionTypeModal(false));
    dispatch(updateStructureWasSaved(false));
  };

  useEffect(() => {
    processSelectedOurNodes(
      setLocalFlatArrayWithAcquisitionTypes,
      setLocalDataAcquisitionType,
      setLocalPollingIntervalInSeconds,
    );
  }, []);

  return (
    <div className={styles[cssClassName]}>
      <div className={styles[`${cssClassName}__backdrop`]} />
      <div className={styles[`${cssClassName}__modal`]}>
        <SubHeader>
          <div style={{ width: 24 }}></div>
          <SubTitle
            text={i18n(
              "modules.bulkEditDataAcquisitionModal.subHeaderSubTitle",
            )}
          />
          <IconButton fun={closeModalClickHandler} icon={closeIcon} />
        </SubHeader>
        <div className={styles[`${cssClassName}__modal-content`]}>
          <SubTitle
            text={i18n("modules.bulkEditDataAcquisitionModal.subTitle")}
          />
          <BulkDataAcquisitionTypeAndIntervalInputsWrapper
            dataAcquisitionTypeDropdownValue={localDataAcquisitionType}
            pollingIntervalInSeconds={localPollingIntervalInSeconds}
            callbackForDataAcquisitionTypeValue={
              callbackForDataAcquisitionTypeValue
            }
            callbackForPollingIntervalTime={callbackForPollingIntervalTime}
          />
          <div
            className={styles[`${cssClassName}__modal-content-button-wrapper`]}
          >
            <Button
              fun={applyChanges}
              text={i18n("modules.bulkEditDataAcquisitionModal.applyButton")}
              variant={[manageDisableApplyButton() ? "inactive" : ""]}
              disabled={manageDisableApplyButton()}
            />
            <Button
              fun={closeModalClickHandler}
              text={i18n("modules.bulkEditDataAcquisitionModal.cancelButton")}
              variant={["secondary"]}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
